import { StyleSheet } from '@react-pdf/renderer'

const tableStyles = StyleSheet.create({
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 17
  },
  serviceCol: {
    flex: 2,
    paddingLeft: 8
  },
  costShareCol: {
    flex: 2
  },
  deductibleCol: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row'
  },
  cellText: {
    fontSize: 7
  }
})

export default tableStyles
